<template>
    <main class="J-body" :class="isHomePage ? '' : 'J-body-public'">
        <HeaderPartial v-if="!isHomePage" />
        <div class="J-main-container">
            <router-view></router-view>
        </div>

    </main>
</template>
<script>
import HeaderPartial from '../partials/Header.partial.vue'
export default {
    components: {
        HeaderPartial
    },
    computed: {
        isHomePage() {
            return this.$route.name === 'home'
        }
    }
}
</script>